import React from "react";
import { Box } from "@material-ui/core";

export default function Error() {
  return <Box>Aww fuck. you made an error</Box>;
}
